import { useLocation } from 'react-router-dom'

import ScreenFrame from 'components/Frame/ScreenFrame'

export default function PDFView() {

    const location = useLocation()
    const pdfURL = location.state?.pdfURL || null

    return (
        <ScreenFrame limitWidth={false}>
            <div className='-m-6'>
                {pdfURL !== null && pdfURL !== undefined && 
                    <iframe 
                        className='w-full h-screen'
                        src={pdfURL}
                    />
                }
            </div>
        </ScreenFrame>
    )
}